// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_d1ac3e', '__Poppins_Fallback_d1ac3e'","fontStyle":"normal"},"className":"__className_d1ac3e","variable":"__variable_d1ac3e"};